module.exports = __webpack_public_path__ + "img/hair_back_male_afro.3dbda3dd.png";